import wolfram from "refractor/wolfram";
export default wolfram;